import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router";
import { push } from "connected-react-router";
import axios from "axios";
import swal from "sweetalert";
import { Button, Col, Form, FormGroup, Input, Label } from "reactstrap";
import Widget from "../../components/Widget/Widget";
import { API_TIMEOUT, NIRLABA_JENIS, NIRLABA_LEMBAGA } from "../../utils/index";
import {
  getMitraLembagaId,
  getStoredUser,
  isAdminMitra,
} from "../../utils/adminMitra";

const JenisNirlabaForm = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const [lembaga, setLembaga] = useState([]);
  const [idLembaga, setIdLembaga] = useState("");
  const [bantuan, setBantuan] = useState("");
  const [sumberDana, setSumberDana] = useState("NGO");
  const [bentuk, setBentuk] = useState("");
  const [target, setTarget] = useState("");
  const [jenis, setJenis] = useState("");
  const [keterangan, setKeterangan] = useState("");

  useEffect(() => {
    axios
      .get(NIRLABA_LEMBAGA, { timeout: API_TIMEOUT })
      .then((res) => {
        const user = getStoredUser();
        const lid = getMitraLembagaId(user);
        let data = res.data?.data || [];
        if (isAdminMitra(user) && lid) {
          data = data.filter((x) => Number(x.id) === lid);
          setIdLembaga(String(lid));
        }
        setLembaga(data);
      })
      .catch((err) => alert(err));
  }, []);

  useEffect(() => {
    if (!id) return;
    axios
      .get(NIRLABA_JENIS + "/" + id, { timeout: API_TIMEOUT })
      .then((res) => {
        const row = res.data?.data?.[0];
        if (!row) return;
        setIdLembaga(String(row.id_lembaga || ""));
        setBantuan(row.bantuan || "");
        setSumberDana(row.sumber_dana || "NGO");
        setBentuk(row.bentuk || "");
        setTarget(row.target || "");
        setJenis(row.jenis || "");
        setKeterangan(row.keterangan || "");
      })
      .catch((err) => alert(err));
  }, [id]);

  const simpan = async (e) => {
    e.preventDefault();
    if (!id) {
      const cek = await axios.post(
        NIRLABA_JENIS + "/check",
        { id_lembaga: idLembaga, bantuan },
        { timeout: API_TIMEOUT }
      );
      if ((cek.data?.data || []).length) {
        swal("Tidak bisa", "Program ini sudah ada untuk lembaga tersebut", "warning");
        return;
      }
    }
    const payload = {
      id_lembaga: idLembaga,
      bantuan,
      sumber_dana: sumberDana,
      bentuk,
      target,
      jenis,
      keterangan,
    };
    const req = id
      ? axios.patch(NIRLABA_JENIS + "/" + id, payload, { timeout: API_TIMEOUT })
      : axios.post(NIRLABA_JENIS, payload, { timeout: API_TIMEOUT });
    req
      .then((res) => {
        if (res.data?.success === 1) {
          swal("Sukses", "Program tersimpan", "success");
          dispatch(push("/admin/nirlaba/jenis"));
        } else {
          swal("Gagal", res.data?.message || "Gagal simpan", "error");
        }
      })
      .catch((err) => swal("Gagal", err.message, "error"));
  };

  return (
    <div>
      <div className="page-top-line">
        <h2 className="page-title">{id ? "Edit program mitra" : "Input program mitra"}</h2>
      </div>
      <Widget>
        <Form onSubmit={simpan}>
          <FormGroup row>
            <Label md={3} className="text-md-right">
              Lembaga
            </Label>
            <Col md={8}>
              <Input
                type="select"
                value={idLembaga}
                onChange={(e) => setIdLembaga(e.target.value)}
                required
                disabled={isAdminMitra(getStoredUser())}
              >
                <option value="">Pilih lembaga</option>
                {lembaga.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.nama_lembaga}
                  </option>
                ))}
              </Input>
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label md={3} className="text-md-right">
              Nama program
            </Label>
            <Col md={8}>
              <Input value={bantuan} onChange={(e) => setBantuan(e.target.value)} required />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label md={3} className="text-md-right">
              Sumber dana
            </Label>
            <Col md={8}>
              <Input
                type="select"
                value={sumberDana}
                onChange={(e) => setSumberDana(e.target.value)}
              >
                <option value="NGO">NGO</option>
                <option value="CSR">CSR</option>
                <option value="Swasta">Swasta</option>
                <option value="Hibah luar">Hibah luar</option>
              </Input>
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label md={3} className="text-md-right">
              Bentuk
            </Label>
            <Col md={8}>
              <Input value={bentuk} onChange={(e) => setBentuk(e.target.value)} />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label md={3} className="text-md-right">
              Target
            </Label>
            <Col md={8}>
              <Input value={target} onChange={(e) => setTarget(e.target.value)} />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label md={3} className="text-md-right">
              Jenis
            </Label>
            <Col md={8}>
              <Input value={jenis} onChange={(e) => setJenis(e.target.value)} />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label md={3} className="text-md-right">
              Keterangan
            </Label>
            <Col md={8}>
              <Input
                type="textarea"
                value={keterangan}
                onChange={(e) => setKeterangan(e.target.value)}
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label md={3} />
            <Col md={8}>
              <Button color="primary" type="submit" className="mr-2">
                Simpan
              </Button>
              <Button
                color="secondary"
                type="button"
                onClick={() => dispatch(push("/admin/nirlaba/jenis"))}
              >
                Batal
              </Button>
            </Col>
          </FormGroup>
        </Form>
      </Widget>
    </div>
  );
};

export default JenisNirlabaForm;
